module.exports = __webpack_public_path__ + "img/daswarennochZeiten.b6ee872e.svg";